import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import './Common.scss';

export default function SuccessPage() {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // location.stateから取得するか、URLパラメータから取得
  const typeFromState = location.state?.type;
  const typeFromParams = searchParams.get('type');
  const type = typeFromState || typeFromParams || 'reserve';

  const content = type === 'contact' ? 'お問い合わせ' : 'ご予約';
  return (
    <Container fluid>
      <Row>
        <Col>
          <h2 className="white-stroke">{content}ありがとうございます！</h2>
          <p className="white-stroke">
            ご入力いただいたメールアドレスに確認メールをお送りしました。
          </p>
          <img
            src={require('../images/aria_mini_smile.jpeg')}
            alt="画像は開発中のものです"
          />
          <Link to="/">トップへ戻る</Link>
        </Col>
      </Row>
    </Container>
  );
}
